import React, { useEffect } from 'react';
import './App.css';
import { NavBar } from './components/NavBar';
import { Banner } from './components/Banner';
import { ProblemSection } from './components/ProblemSection';
import { SystemBuilderSection } from './components/SystemBuilderSection';
import { ICPSection } from './components/ICPSection';
import { CaseStudies } from './components/CaseStudies';
import { AboutTeaserSection } from './components/AboutTeaserSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Pricing } from './components/Pricing';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { EnvironmentBanner } from './components/EnvironmentBanner';
import { CookieConsent } from './components/CookieConsent';
import ErrorBoundary from './components/ErrorBoundary';
import { initGA, trackPageView, trackEnvironment } from './lib/analytics';
import { getConsent, onConsentChange, CONSENT_ACCEPTED } from './lib/consent';
import 'bootstrap/dist/css/bootstrap.min.css';

const VENDASTA_WIDGET_ID = 'edd1fc6b-e0ea-11f0-b0de-4aca21529b09';
const VENDASTA_SCRIPT_SRC = 'https://cdn.apigateway.co/webchat-client..prod/sdk.js';

function loadVendastaWidget() {
  if (document.querySelector(`script[data-widget-id="${VENDASTA_WIDGET_ID}"]`)) return;
  const script = document.createElement('script');
  script.src = VENDASTA_SCRIPT_SRC;
  script.setAttribute('data-widget-id', VENDASTA_WIDGET_ID);
  script.defer = true;
  document.head.appendChild(script);
}

function applyConsent(consent) {
  if (consent !== CONSENT_ACCEPTED) return;
  initGA();
  trackPageView(window.location.pathname);
  trackEnvironment();
  loadVendastaWidget();
}

function App() {
  useEffect(() => {
    // Apply current consent (if visitor already chose Accept on a prior visit
    // the scripts load on every subsequent page load).
    applyConsent(getConsent());

    // React to the banner Accept click for first-time visitors and to the
    // footer "Cookie Preferences" → Accept flow.
    const off = onConsentChange(applyConsent);
    return off;
  }, []);

  return (
    <ErrorBoundary>
      <EnvironmentBanner />
      <div className="App">
        <a className="skip-link" href="#main-content">Skip to main content</a>
        <NavBar />
        <main id="main-content">
          <Banner />
          <ProblemSection />
          <SystemBuilderSection />
          <ICPSection />
          <Pricing />
          <CaseStudies />
          <AboutTeaserSection />
          <FinalCTASection />
          <Contact />
        </main>
        <Footer />
        <CookieConsent />
      </div>
    </ErrorBoundary>
  );
}

export default App;
